import { IMAGES } from "./site";

// Keyword-targeted SEO landing pages. Each renders at /:slug
// Positioned for the whole Dallas–Fort Worth (DFW) area, including Denton, TX.
export const SERVICE_PAGES = [
  {
    slug: "apartment-turnover-cleaning-denton-tx",
    tag: "Apartment Communities",
    short: "Apartment Turnover Cleaning",
    h1: "Apartment Turnover Cleaning in the DFW Area",
    title:
      "Apartment Turnover Cleaning DFW & Denton TX | Fast Make-Ready | Jet Cleaning Service",
    description:
      "DFW's apartment turnover cleaning specialists serving Denton and the entire Dallas–Fort Worth Metroplex. Dependable make-ready cleaning with fast same-day/next-day turnaround to reduce unit downtime. Request apartment pricing.",
    intro:
      "Vacant units cost you money every day they sit. Jet Cleaning Service helps apartment communities across the Dallas–Fort Worth Metroplex — including Denton — turn units faster with dependable, detail-focused make-ready cleaning, so your team can lease with confidence and residents move into a spotless home.",
    image: IMAGES.apartment1,
    included: [
      "Full make-ready unit cleaning",
      "Kitchens, appliances & cabinets",
      "Bathrooms & fixtures detailed",
      "Floors, baseboards & window sills",
      "Clubhouses & leasing offices",
      "Fitness centers & common areas",
      "Hallways & breezeways",
      "Punch-list & final touch-ups",
    ],
    why: [
      "Fast same-day & next-day turnaround when available",
      "Reliable scheduling that keeps your board moving",
      "Consistent, inspection-ready quality every unit",
      "Clear communication with your property team",
    ],
    related: [
      "make-ready-cleaning-denton-tx",
      "move-out-cleaning-denton-tx",
      "commercial-cleaning-denton-tx",
    ],
  },
  {
    slug: "make-ready-cleaning-denton-tx",
    tag: "Apartments",
    short: "Make Ready Cleaning",
    h1: "Make Ready Cleaning in the DFW Area",
    title:
      "Make Ready Cleaning DFW & Denton TX | Vacant Unit Turnovers | Jet Cleaning Service",
    description:
      "Professional make-ready cleaning across DFW and Denton, TX for apartment communities and property managers. Get vacant units rent-ready fast with dependable, consistent results.",
    intro:
      "Our make-ready cleaning gets vacant units rent-ready fast. We handle the deep, detailed clean between residents for communities throughout the Dallas–Fort Worth area, including Denton — on a schedule you can count on.",
    image: IMAGES.apartment2,
    included: [
      "Top-to-bottom vacant unit clean",
      "Appliance interior & exterior",
      "Cabinet & drawer wipe-down",
      "Sanitized bathrooms",
      "Detailed floor care",
      "Baseboards, blinds & vents",
      "Windows & tracks",
      "Move-in ready inspection",
    ],
    why: [
      "Built for apartment turn schedules",
      "No service minimums in our primary area",
      "Priority scheduling for communities",
      "Meticulous, inspection-ready detail",
    ],
    related: [
      "apartment-turnover-cleaning-denton-tx",
      "move-out-cleaning-denton-tx",
      "deep-cleaning-denton-tx",
    ],
  },
  {
    slug: "move-out-cleaning-denton-tx",
    tag: "Move In / Move Out",
    short: "Move Out & Move In Cleaning",
    h1: "Move Out & Move In Cleaning in the DFW Area",
    title:
      "Move Out Cleaning DFW & Denton TX | Move In Cleaning | Jet Cleaning Service",
    description:
      "Move out and move in cleaning across the DFW area, including Denton, TX. Deep, detailed cleaning to help you get your deposit back or start fresh in a spotless new home. Book today.",
    intro:
      "Moving is stressful enough. Whether you're leaving a rental and want your deposit back, or moving into a new place that deserves a fresh start, our move in/move out cleaning delivers a thorough, detailed clean anywhere in the Dallas–Fort Worth area, including Denton.",
    image: IMAGES.residential2,
    included: [
      "Whole-home deep clean",
      "Inside cabinets & closets",
      "Oven, fridge & appliances",
      "Scrubbed bathrooms",
      "Baseboards & door frames",
      "Interior windows & tracks",
      "Floors mopped & vacuumed",
      "Final walkthrough",
    ],
    why: [
      "Deposit-focused, detailed results",
      "Flexible day & evening appointments",
      "Trusted, background-minded service",
      "Clear, upfront pricing",
    ],
    related: [
      "make-ready-cleaning-denton-tx",
      "house-cleaning-denton-tx",
      "deep-cleaning-denton-tx",
    ],
  },
  {
    slug: "commercial-cleaning-denton-tx",
    tag: "Commercial",
    short: "Commercial Cleaning",
    h1: "Commercial Cleaning in the DFW Area",
    title:
      "Commercial Cleaning DFW & Denton TX | Offices & Businesses | Jet Cleaning Service",
    description:
      "Dependable commercial cleaning across the Dallas–Fort Worth Metroplex, including Denton, TX. Offices, medical suites, retail and professional buildings cleaned on your schedule. Request a commercial quote.",
    intro:
      "A clean workplace creates a better experience for employees, customers, and visitors. Jet Cleaning Service provides dependable commercial cleaning tailored to your schedule — day or evening — for businesses throughout DFW, including Denton, so your business always makes a great impression.",
    image: IMAGES.commercial,
    included: [
      "Offices & office suites",
      "Reception & common areas",
      "Break rooms & kitchens",
      "Restroom sanitizing",
      "Trash removal",
      "Surface disinfecting",
      "Dusting & vacuuming",
      "Floor care",
    ],
    why: [
      "Work around your business hours",
      "Consistent, dependable results",
      "Responsive communication",
      "Licensed & insured",
    ],
    related: [
      "office-cleaning-denton-tx",
      "recurring-cleaning-denton-tx",
      "apartment-turnover-cleaning-denton-tx",
    ],
  },
  {
    slug: "office-cleaning-denton-tx",
    tag: "Commercial",
    short: "Office Cleaning",
    h1: "Office Cleaning in the DFW Area",
    title: "Office Cleaning DFW & Denton TX | Professional Buildings | Jet Cleaning Service",
    description:
      "Professional office cleaning across DFW and Denton, TX. Keep your workspace spotless and productive with reliable recurring or one-time office cleaning. Get a free quote.",
    intro:
      "Keep your office spotless, healthy, and productive. We provide reliable office cleaning for professional buildings, suites, and small businesses across the Dallas–Fort Worth area, including Denton — customized to your space and schedule.",
    image: IMAGES.commercial,
    included: [
      "Workstations & desks",
      "Reception areas",
      "Conference rooms",
      "Break rooms & kitchens",
      "Restroom sanitizing",
      "Trash & recycling",
      "Dusting & surfaces",
      "Vacuum & floor care",
    ],
    why: [
      "Day or evening appointments",
      "Weekly, bi-weekly or monthly",
      "Consistent, detailed quality",
      "Responsive, professional support",
    ],
    related: [
      "commercial-cleaning-denton-tx",
      "recurring-cleaning-denton-tx",
      "deep-cleaning-denton-tx",
    ],
  },
  {
    slug: "house-cleaning-denton-tx",
    tag: "Residential",
    short: "House Cleaning",
    h1: "House Cleaning in the DFW Area",
    title: "House Cleaning DFW & Denton TX | Residential Cleaning | Jet Cleaning Service",
    description:
      "Reliable house cleaning across the DFW area, including Denton, TX, for busy professionals, parents, and families. Recurring housekeeping or one-time cleans tailored to your home. Book today.",
    intro:
      "Come home to a cleaner, healthier space. Whether you need recurring housekeeping or a one-time refresh, we'll create a customized cleaning plan that fits your home and your lifestyle — serving families throughout the Dallas–Fort Worth area, including Denton.",
    image: IMAGES.residential,
    included: [
      "Kitchens & appliances",
      "Bathrooms & fixtures",
      "Bedrooms & living areas",
      "Dusting & surfaces",
      "Floors vacuumed & mopped",
      "Baseboards & trim",
      "Trash removal",
      "Tidy, finished touches",
    ],
    why: [
      "Customized to your home",
      "Recurring or one-time",
      "Flexible scheduling",
      "Trusted, dependable service",
    ],
    related: [
      "deep-cleaning-denton-tx",
      "recurring-cleaning-denton-tx",
      "move-out-cleaning-denton-tx",
    ],
  },
  {
    slug: "deep-cleaning-denton-tx",
    tag: "Residential",
    short: "Deep Cleaning",
    h1: "Deep Cleaning in the DFW Area",
    title: "Deep Cleaning DFW & Denton TX | Top-to-Bottom Clean | Jet Cleaning Service",
    description:
      "Thorough deep cleaning across DFW and Denton, TX. A meticulous top-to-bottom clean for homes that need extra attention. Perfect before events or as a fresh reset. Request a quote.",
    intro:
      "Sometimes your home needs more than a routine tidy. Our deep cleaning is a meticulous, top-to-bottom reset that reaches the details regular cleaning misses — available throughout the Dallas–Fort Worth area, including Denton. Ideal for spring cleaning, before an event, or as your first visit.",
    image: IMAGES.residential2,
    included: [
      "Detailed kitchen & appliances",
      "Grout & tile attention",
      "Baseboards, doors & trim",
      "Blinds, vents & fixtures",
      "Inside windows & tracks",
      "Cabinet fronts",
      "Full bathroom detail",
      "Floors deep cleaned",
    ],
    why: [
      "Meticulous, no corners skipped",
      "Great one-time reset",
      "Flexible day/evening times",
      "Consistent, dependable results",
    ],
    related: [
      "house-cleaning-denton-tx",
      "move-out-cleaning-denton-tx",
      "recurring-cleaning-denton-tx",
    ],
  },
  {
    slug: "recurring-cleaning-denton-tx",
    tag: "Residential & Commercial",
    short: "Recurring Cleaning",
    h1: "Recurring Cleaning in the DFW Area",
    title: "Recurring Cleaning DFW & Denton TX | Weekly & Bi-Weekly | Jet Cleaning Service",
    description:
      "Recurring cleaning across DFW and Denton, TX — weekly, bi-weekly, or monthly service for homes and businesses. Consistent teams, priority scheduling, dependable results. Get started.",
    intro:
      "Keep your home or business consistently clean without lifting a finger. Our recurring cleaning gives you priority scheduling and dependable, detailed results on the cadence that works for you — weekly, bi-weekly, or monthly — throughout the Dallas–Fort Worth area, including Denton.",
    image: IMAGES.residential,
    included: [
      "Weekly, bi-weekly or monthly",
      "Kitchens & bathrooms",
      "Living & work areas",
      "Dusting & surfaces",
      "Floor care",
      "Trash removal",
      "Priority scheduling",
      "Flexible as-needed visits",
    ],
    why: [
      "Set-it-and-forget-it convenience",
      "Priority scheduling for regulars",
      "Consistent, dependable quality",
      "Easy to adjust anytime",
    ],
    related: [
      "house-cleaning-denton-tx",
      "office-cleaning-denton-tx",
      "deep-cleaning-denton-tx",
    ],
  },
];

export const getServicePage = (slug) =>
  SERVICE_PAGES.find((p) => p.slug === slug);
